<template>
  <div class="subpage-header">
    <div class="content">
      <div class="banner">
        <img :src="subData.img" alt="" />
        <div class="box">
          <div class="title-box">
            <div class="title">{{ subData.title }}</div>
            <div class="en-title">{{ subData.enTitle }}</div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="position df">
          <div class="text">当前位置：</div>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }"><i class="el-icon-s-home" /> 首页</el-breadcrumb-item>
            <el-breadcrumb-item
              v-for="item in subData.breadcrumb"
              :key="item.id"
              >
              {{ item.text }}</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subData: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.subpage-header {
  .banner {
    position: relative;

    img {
      width: 100%;
      height: 400px;
    }

    .box {
      width: 1400px;
      margin: 0 auto;

      .title-box {
        width: 240px;
        height: 124px;
        position: absolute;
        bottom: 5px;
        background: #c30d23;
        color: #fff;
        padding-left: 36px;
        padding-top: 32px;

        .title {
          font-size: 28px;
        }

        .en-title {
          font-size: 14px;
        }
      }
    }
  }

  .position {
    margin: 12px 0;
    font-family: PuHuiTi-65;

    .text {
      color: #156aa3;
      font-size: 12px;
    }

    ::v-deep .el-breadcrumb__inner {
      color: #575b66;
      font-weight: normal;
      font-size: 12px;
    }
  }
}
</style>
